import {FC, useState, useEffect} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {showSwal} from '../../../../ui-kit'
import {getPendingHSDescription, submitHSDescriptionReview} from './core/_requests'
import useAxiosPrivate from '../../../libs/useAxiosPrivate'
import {useNavigate, useParams} from 'react-router-dom'
import {HSDescriptionDetail} from './core/_models'
import './MasterDataHSDescriptionReviewPage.scss'
import HSDescriptionPendingForm from './components/HSDescriptionPendingForm'
import HSDescriptionComparisonForm from './components/HSDescriptionComparisonForm'



const MasterDataHSDescriptionReviewPage: FC = () => {
  const axiosPrivate = useAxiosPrivate()
  const navigate = useNavigate()
  const {id} = useParams()
  const [isLoadingHS, setIsLoadingHS] = useState(false)
  const [isLoadingButton, setIsLoadingButton] = useState(false)
  const [isFormValid, setIsFormValid] = useState(false)

  const initialHS: HSDescriptionDetail = {
    id: '',
    version: '',
    description: '',
    level: '',
    parent: null,
    description_fr: '',
    original_id: null,
  }

  const [hsPending, setHsPending] = useState<HSDescriptionDetail>(initialHS)
  const [hsOrigin, setHsOrigin] = useState<HSDescriptionDetail>(initialHS)

  const isDifferent = (originVal: any, newVal: any) => {
    if (!originVal && !newVal) return false
    return String(originVal || '').trim() !== String(newVal || '').trim()
  }

  const fetchPendingHS = async () => {
    try {
      setIsLoadingHS(true)

      const res = await getPendingHSDescription(axiosPrivate, {id})
      const data = res.data.data
      console.log(res)

      if (data) {
        const pending = data.pending
        const origin = data.original ? data.original : null

        setHsPending((prev) => ({...prev, ...pending}))
        setHsOrigin((prev) => ({...prev, ...origin}))
      }
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoadingHS(false)
    }
  }

  useEffect(() => {
    fetchPendingHS()
  }, [])

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    const {name, value} = e.target as HTMLInputElement

    setHsPending((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const {name, value} = e.target
    setHsPending((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const validateRequiredFields = () => {
    const requiredFields = ['id', 'version', 'level', 'description']

    const isValid = requiredFields.every((key) => {
      const val = (hsPending as any)[key]
      return val !== undefined && val !== null && String(val).trim() !== ''
    })

    setIsFormValid(isValid)
  }

  useEffect(() => {
    validateRequiredFields()
  }, [hsPending])

  const handleSubmit = () => {
    const payload = {...hsPending}

    if (payload.parent === '' || payload.parent === undefined) {
      payload.parent = null
    }

    showSwal({
      title: 'Are you sure you want to submit this review?',
      icon: 'question',
    }).then((result) => {
      if (!result.isConfirmed) return

      setIsLoadingButton(true)

      submitHSDescriptionReview(axiosPrivate, id, payload)
        .then((res) => {
          if (res.status === 200) {
            showSwal('HS Description reviewed', undefined, 'success').then(() => {
              navigate('/master-data-hs-descriptions')
            })
          }
        })
        .catch((err) => {
          console.error(err)
          showSwal('Error', 'Failed to submit review', 'error')
        })
        .finally(() => {
          setIsLoadingButton(false)
        })
    })
  }

  const handleCancel = () => {
    showSwal({
      title: 'Are you sure you want to cancel?',
      icon: 'question',
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload()
      }
    })
  }

  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Home',
            path: '/',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
          {
            title: 'Master Data',
            path: '',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
          {
            title: 'HS Description',
            path: 'master-data-hs-descriptions',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
        ]}
      >
        Review HS Description
      </PageTitle>
      <div className='MasterDataHSDescriptionReviewPage'>
        <div className='row'>
          {hsOrigin.id != null ? (
            <div className='col-12'>
              <HSDescriptionComparisonForm
                isLoadingHS={isLoadingHS}
                hsOrigin={hsOrigin}
                hsPending={hsPending}
                isDifferent={isDifferent}
                handleChange={handleChange}
                handleSelectChange={handleSelectChange}
                handleCancel={handleCancel}
                handleSubmit={handleSubmit}
                isLoadingButton={isLoadingButton}
                isFormValid={isFormValid}
              />
            </div>
          ) : (
            <div className='col-12'>
              <HSDescriptionPendingForm
                isLoadingHS={isLoadingHS}
                hsOrigin={hsOrigin}
                hsPending={hsPending}
                isDifferent={isDifferent}
                handleChange={handleChange}
                handleSelectChange={handleSelectChange}
                handleCancel={handleCancel}
                handleSubmit={handleSubmit}
                isLoadingButton={isLoadingButton}
                isFormValid={isFormValid}
              />
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default MasterDataHSDescriptionReviewPage
